import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { Carousel } from 'react-bootstrap'
import { data } from '../../data'
import { useDispatch, useSelector } from 'react-redux'
import { setActivePage } from '../../slices/uiSlice'
import { Icon } from '../../components'
import { Button, Card } from 'react-bootstrap'


import Aos from 'aos'
import 'aos/dist/aos.css'

import './home.scss'

const SectionProducts = ( { imgs, urlPath, phoneResponse, title, showing, id }: any) => {
    const dispatch = useDispatch()
    const [imgsMap, setImgsMap] = useState<any[]>([])

    const onActive = useCallback((e: any) => {
        dispatch(setActivePage(Number(e.currentTarget.id)))
    },[dispatch])

    useEffect(() => {
        setImgsMap(phoneResponse ? imgs.slice(0,3) : imgs)
    },[phoneResponse])

    return (
        <div className='products' data-aos={showing}>
            <span>{title}</span>
            <span>■</span>
            
            <Link to={`/${urlPath}`} onClick={onActive} id={id} >
                <button>
                    {!phoneResponse ? 'Разгледай всички' : ''}
                    <Icon
                        iconName='ArrowRight'
                        size={20}
                    />
                </button>
            </Link>
            
            <div className='section-pics'>
                {
                    imgsMap.map((img: any) => {
                        return (
                            <img src={`/images/${img}.jpg`} key={img}/>
                        )
                    })
                }
            </div>
        </div>
    )
}

export const Home = () => {
    const [phoneResponse, setPhoneResponse] = useState<number>(0)
    const { activePage } = useSelector((state: any) => state.ui)

    const isMarch = useMemo(() => {
        const date = new Date()
        const day = date.getDate()
        const month = date.getMonth() + 1

        return (month === 2 && day >= 15) || (month === 3 && day <= 30)
            
    },[])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        Aos.init({duration: 1000, once: true})
    },[])

    const handleResize = useCallback(() => {
        setPhoneResponse(window.innerWidth <= 800 ? window.innerWidth : 0)
    },[])
    
    useEffect(() => {
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    },[handleResize, ])

    useEffect(() => {
        activePage === 0 && handleResize()
    },[activePage])
  
    return (
        <div className='home'>
            <div>
                <div className='info' >
                    <div className='before-text'>
                        <div className='line'/>
                        <span>■</span>
                        <p>БРАНД С КАУЗА</p>
                    </div>
                    <h3>БРАНД С КАУЗА ЗА ДЕЦА В НУЖДА!</h3>  
                    <div className='order-info'>
                        <div className='item'>
                            <svg viewBox="0 0 120 80" fill="currentColor" style={{color: 'rgb(234, 226, 226)', width:'70px', height: '70px'}}>
                                <g stroke="#C9A96E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    
                                    {/* Cargo box  */}
                                    <rect x="30" y="20" width="45" height="30" rx="2"/>
        
                                    {/* <!-- Cabin --> */}
                                    <path d="M75 25 L95 25 L105 35 L105 50 L75 50 Z"/>
        
                                    {/* <!-- Wheels --> */}
                                    <circle cx="45" cy="50" r="6"/>
                                    <circle cx="85" cy="50" r="6"/>
        
                                    {/* <!-- Speed lines --> */}
                                    <line x1="10" y1="30" x2="30" y2="30"/>
                                    <line x1="15" y1="38" x2="30" y2="38"/>
                                    <line x1="10" y1="46" x2="25" y2="46"/>
        
                                </g>
                            </svg>
                            <div>
                                <p>Безплатна доставка за поръчки над</p>
                                <p>200лв/102.25€</p>
                            </div>
                        </div>
        
                        <div className='item'>
                            <Icon
                                iconName="Printer"
                                color="#C9A96E"
                                size={35}
                            />
                            <div>
                                <p>Печат с вашето лого или име</p>
                                <p>+20лв/10.22€</p>
                            </div>
                        </div>
        
                        <div className='item'>
                            <Icon
                                iconName="Gift"
                                color="#C9A96E"
                                size={35}
                            />
                            <div>
                                <p>Персонализирана опаковка</p>
                                <p>+10лв/5.11€</p>
                            </div>
                        </div>
                    </div>
                    <div className='rule'>
                        <Icon
                            iconName='ExclamationCircle'
                            color='red'
                            size={35}
                        />
                        <h4>След направен преглед и заплащане на поръчан от Вас артикул, стоката не ПОДЛЕЖИ на връщане!</h4>
                    </div>
                    <hr />
                    <p> 
                        Добре дошли в света на елегантността, стила и качеството в ShineCo.
                        ShineCo. е онлайн магазин за артикули от епоксидна смола. 
                        Ръчно изработени с артистичност във всеки детайл.
                        Бранд Създаден през 2021г. в България гр.Варна. 

                        При нас ще откриете множество модели,
                        които биха били не само отлично допълнение към Вашият дом или офис , 
                        но и прекрасен подарък, с който да зарадвате близките си и любими хора! 

                        Ако вече сте се сдобили с някой от нашите артикули, които предлагаме
                        и Ви допадат, ще се радваме да споделите своето мнение и да ни 
                        препоръчате на Вашите приятели.
                        Ако все още не сте то с удоволствие ще Ви помогнем при избора на Вашето ново "Бижу"!
                        Връзката с клиентите е специална за нас!
                        Нaшата цел е клиентът да остане доволен от качеството, избора и обслужването.
                    </p>
                </div>
                <div className='corosel'>
                    <Carousel fade pause={false} controls={false} indicators={false}>
                        {/* {
                            isMarch &&
                                <Carousel.Item>
                                    <img 
                                        src='/images/Baner-8-Marth.jpg'
                                        alt='x-mas'
                                        className='d-block w-100'
                                    />
                                </Carousel.Item>
                        } */}

                        {/* {
                            isMarch &&
                                <Carousel.Item>
                                    <img
                                        src='/images/Baner-8-Marth1.jpg'
                                        alt='x-mas'
                                        className='d-block w-100'
                                    />
                                </Carousel.Item>
                        } */}

                        <Carousel.Item>
                            <img
                                src="/images/12.jpg"
                                alt="table"
                                className="d-block w-100"
                            />
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                src="/images/A7102250.jpg"
                                alt="salver"
                                className="d-block w-100"
                            />
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                src="/images/korica.jpg"
                                alt="table"
                                className="d-block w-100"
                            />
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                src="/images/A7100747.jpg"
                                alt="table"
                                className="d-block w-100"
                            />
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                src="/images/A7101645.jpg"
                                alt="table"
                                className="d-block w-100"
                            />
                        </Carousel.Item>

                        <Carousel.Item>
                            <img
                                src="/images/A7100001.jpg"
                                alt="table"
                                className="d-block w-100"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
            </div>
            <div>
                <SectionProducts urlPath='product-pads?activePage=1' title='Подложки' showing='zoom-in-up' id='1' imgs={['1', 'A7101645',  'A7101709',  'A7102250',  'A7204149',  'A7203726']} phoneResponse={phoneResponse}/>
                <SectionProducts urlPath='product-salver?activePage=2' title='Подноси' showing='zoom-in-right' id='2' imgs={['25', '26',  '24',  'A7107839web2',  'A7203817',  'A7103668-2']} phoneResponse={phoneResponse}/>
                <SectionProducts urlPath='product-clocks?activePage=3' title='Часовници' showing='zoom-in' id='3' imgs={['12f', 'A7101723',  '12',  '12a',  '12b',  '12e']} phoneResponse={phoneResponse}/>
                <SectionProducts urlPath='product-tables?activePage=4' title='Маси' showing='zoom-in-down' id='4' imgs={['11', '16a',  '19a',  'A7402908',  '17c',  'A7200147-2']} phoneResponse={phoneResponse}/>
                <SectionProducts urlPath='other-product?activePage=5' title='Други' showing='zoom-in-right' id='5' imgs={['A7203166', '27d',  '13a',  'A7103117',  'A7102658',  'A7102596']} phoneResponse={phoneResponse}/>
            </div>
            <div className='video'>
                <p>Релаксирайте със ShineCo.</p>
                <video src='/images/Coaster.mp4' controls poster='/images/_SDS5930.jpg'></video>
            </div>
            
        </div>
    )
}